var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShotEyesUser = function SvgShotEyesUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "shotEyesUser_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".shotEyesUser_svg__st0{fill:none;stroke:#333;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:2}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10c1.9 0 3.5-1.6 3.5-3.5S11.4 3 9.5 3 6 4.6 6 6.5 7.6 10 9.5 10M16.3 3.5c1 .6 1.7 1.7 1.7 3s-.7 2.4-1.7 3M2 20.4v.6h15v-.6c0-2.2 0-3.4-.4-4.2s-1-1.4-1.7-1.7c-.9-.5-2.1-.5-4.3-.5H8.4c-2.2 0-3.4 0-4.2.4s-1.4 1-1.7 1.7C2 17 2 18.2 2 20.4M22 21v-.6c0-2.2 0-3.4-.4-4.2s-1-1.4-1.7-1.7",
    className: "shotEyesUser_svg__st0"
  })));
};
export default SvgShotEyesUser;